import { ThumbDownOutlined, ThumbUpOutlined } from "@mui/icons-material";
import { Box, BoxProps, Grid, Typography } from "@mui/material";

import { useChat } from "../hooks/useChat";
import { AnswerFeedbackScore } from "../types";
import { StyledHendrenButton } from "./HendrenButton";

type AnswerFeedbackProps = {
  messageId: string;
  score?: AnswerFeedbackScore | undefined;
} & BoxProps;

export const AnswerFeedback = ({ messageId, score, ...rest }: AnswerFeedbackProps) => {
  const { scoreAnswer, isScoring } = useChat();

  const handleScoreClicked = (feedbackScore: AnswerFeedbackScore) => () => {
    if (score === feedbackScore) {
      return;
    }

    scoreAnswer(messageId, feedbackScore);
  };

  return (
    <Box {...rest}>
      <Typography mb={1.5} fontWeight={600}>
        Was this response helpful?
      </Typography>

      <Box></Box>

      <Grid container spacing={1.5}>
        <Grid item>
          <StyledHendrenButton
            onClick={handleScoreClicked("positive")}
            disabled={isScoring}
            variant={score === "positive" ? "contained" : "outlined"}
            color={score === "positive" ? "active" : "primary"}
            fullWidth
            sx={{
              px: 1.5,
              py: 1,
            }}
          >
            <ThumbUpOutlined
              sx={{
                height: "24px",
                width: "24px",
                mr: 1.5,
              }}
            />
            Yes
          </StyledHendrenButton>
        </Grid>
        <Grid item>
          <StyledHendrenButton
            onClick={handleScoreClicked("negative")}
            disabled={isScoring}
            variant={score === "negative" ? "contained" : "outlined"}
            color={score === "negative" ? "active" : "primary"}
            fullWidth
          >
            <ThumbDownOutlined
              sx={{
                height: "24px",
                width: "24px",
                mr: 1.5,
              }}
            />
            No
          </StyledHendrenButton>
        </Grid>
      </Grid>
    </Box>
  );
};
